<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_553_6208)">
      <path
        d="M14.9297 5.76706L15.644 5.40039M14.9297 8.70039L15.644 9.06706"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.06975 5.76706L1.35547 5.40039M2.06975 8.70039L1.35547 9.06706"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.52688 1.36719L5.64831 4.42519C4.09831 6.09719 4.12688 8.78119 5.67688 10.4239C7.24831 12.0665 9.78403 12.0372 11.334 10.3945C12.9055 8.72252 12.884 6.03852 11.334 4.39585L8.52688 1.36719Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_553_6208">
        <rect width="17" height="13" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
